import {NgModule} from '@angular/core';
import {CoreSharedModule} from '@app/core-shared';
import {CorePortalEntityModule} from '@app/core-portal';
import {devicesServices} from './store';
import {OrgaPortalFeatureDeviceEditComponent} from './components';
import {DeviceDetailComponent, DeviceListComponent} from './containers';
import {CorePortalFeatureMasterDataLocationsModule} from '@app/core-portal/features/master-data/features/locations';
import {DevicePingListComponent} from './containers/device-ping-list/device-ping-list.component';

@NgModule({
  declarations: [
    OrgaPortalFeatureDeviceEditComponent,

    DeviceListComponent,
    DeviceDetailComponent,
    DevicePingListComponent
  ],
  imports: [
    CoreSharedModule,
    CorePortalEntityModule,

    CorePortalFeatureMasterDataLocationsModule.forFeature()
  ],
  exports: [
    OrgaPortalFeatureDeviceEditComponent
  ],
  providers: [
    ...devicesServices
  ]
})
export class DevicesDeclarationsModule {
}
